import { render } from "./LastSighting.vue?vue&type=template&id=88382b3e&scoped=true"
import script from "./LastSighting.vue?vue&type=script&lang=js"
export * from "./LastSighting.vue?vue&type=script&lang=js"

import "./LastSighting.vue?vue&type=style&index=0&id=88382b3e&scoped=true&lang=css"

import exportComponent from "/home/acartia-ops/acartia/src/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88382b3e"]])

export default __exports__